
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAntenna2Off as ObiAntenna2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-antenna-2-off.js';
 
 
 

 
 export const ObiAntenna2Off = createComponent({
   react: React,
   tagName: 'obi-antenna-2-off',
   elementClass: ObiAntenna2OffElement,
   events: {
     
   }
  });
 
 